export const TAB_FONDO = 'leftColDF'
export const TAB_BLOQUES = 'leftColDC'
export const TAB_MIS_DISENOS = 'leftColDM'

export const DEFAULT_SIDEBAR_TAB = TAB_FONDO

/** @param {{ blocksLabelKey?: string }} [options] */
export function getSidebarTabs({ blocksLabelKey = 'bc.blocks' } = {}) {
  return [
    { id: TAB_FONDO, labelKey: 'style.generales.fondo' },
    { id: TAB_BLOQUES, labelKey: blocksLabelKey },
    { id: TAB_MIS_DISENOS, labelKey: 'bc.mydesigns', tourStepId: 'v-step-4' },
  ]
}
